module.exports = __webpack_public_path__ + "static/media/contact-header.e98611a0.jpg";